import React, { lazy, Suspense } from 'react';
import { Loading, PageTitle, useFeatures } from '@cordata/buffet';

const PowerBi = lazy(() => import('~/components/PowerBi/Report'));

const ProgramDashboard = () => {
  const { costrategix } = useFeatures();

  return (
    <div className="pt-3">
      <PageTitle>Program Dashboard</PageTitle>

      {costrategix && (
        <Suspense fallback={<Loading />}>
          <PowerBi />
        </Suspense>
      )}
    </div>
  );
};

export default ProgramDashboard;
